import { Inbox, ShieldCheck } from "lucide-react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Skeleton } from "../ui/skeleton";
import { Alert } from "../ui/alert";
import AssuranceItem from "./AssuranceItem";
import { useHistoriqueAssurances } from "../../lib/hooks/useAssurances";

const BlocHistoriqueAssurances = () => {
  const [parent] = useAutoAnimate();
  const { data: assurances, isError } = useHistoriqueAssurances();

  return (
    <section className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_14px_40px_-34px_rgba(15,23,42,0.5)]'>
      <div className='flex items-center gap-3 border-b border-slate-100 bg-[#f5f8f6] px-5 py-4 sm:px-6'>
        <div className='flex h-10 w-10 items-center justify-center rounded-xl bg-[#deece5] text-[#255b4b]'>
          <ShieldCheck className='h-5 w-5' />
        </div>
        <div>
          <h2 className='font-bold text-slate-950'>Historique d'assurances</h2>
        </div>
      </div>
      <div className='p-5 sm:p-6'>
        <div ref={parent} className='flex flex-col gap-6'>
          {/* Loading */}
          {!assurances && (
            <>
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
              <Skeleton className='w-full h-16' />
            </>
          )}

          {/* Error */}
          {isError && (
            <Alert variant={"destructive"} className='text-sm'>
              Une erreur s'est produite au chargement de l'historique
            </Alert>
          )}

          {/* Historique vide */}
          {!!assurances && assurances.length === 0 && (
            <div className='flex flex-col items-center py-8 text-center text-slate-500'>
              <Inbox className='mb-3 h-7 w-7 text-slate-300' />
              <p className='text-sm'>Aucune ancienne assurance.</p>
            </div>
          )}

          {/* Data */}
          {!!assurances && assurances.map((assurance) => <AssuranceItem key={assurance.id} assurance={assurance} />)}
        </div>
      </div>
    </section>
  );
};

export default BlocHistoriqueAssurances;
